module.exports = __webpack_public_path__ + "static/media/steps.aab3d37b.svg";